// extracted by mini-css-extract-plugin
export default {"contentContainer":"TakePart_contentContainer__rE6SC","takePartBtn":"TakePart_takePartBtn__KxVDl"};